// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ValidationError = zod.object({
  "ctx": zod.looseObject({

}).optional(),
  "input": zod.unknown().optional(),
  "loc": zod.array(zod.union([zod.string(),zod.int()])),
  "msg": zod.string(),
  "type": zod.string()
});

export type ValidationError = zod.input<typeof ValidationError>;
export type ValidationErrorOutput = zod.output<typeof ValidationError>;
